<div class="info-popover flex flex-col items-start justify-start gap-2.5">
  <p>· Las medidas de tu portada deben ser las correctas. Para A4 = 21x29.7cm. Para A5 = 14.8x21cm</p>
  <p>· Plastificaremos la primera cara de tu primer documento, respetando la configuración del apartado “portada”.</p>
  <p>· Todas las portadas plastificadas se imprimen a color.</p>
</div>
